import { cn } from "@homeinstead/ui";

function DefaultCheckboxCardIndicator({ checked }: { checked: boolean }) {
  return (
    <div className="flex h-5 shrink-0 items-center">
      <div
        aria-hidden="true"
        className={cn(
          "flex h-4 w-4 items-center justify-center rounded-[2px] border border-new-beginnings-base bg-white",
          checked && "bg-new-beginnings-base",
        )}
        data-testid="default-checkbox-card-indicator"
      >
        {checked && (
          <svg
            className="h-3 w-3 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M5 13l4 4L19 7"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
            />
          </svg>
        )}
      </div>
    </div>
  );
}

export { DefaultCheckboxCardIndicator };
